const GameState = Object.freeze({
  USER_SELECTING_HAND: "user",
  AI_SELECTING_HAND: "ai",
  WON: "won",
  LOSE: "lose",
  DRAW: "draw",
});


export default GameState;